// extracted by mini-css-extract-plugin
export default {"Carrot":"#FB6126","White":"#FFFFFF","notification":"Gb21057 Gd6846a","oldDeliveryDay":"G634c4b"};